import { Component, OnInit } from '@angular/core';
import { ModalBase, language, modal, ConfirmDialogComponent, color } from 'curvy';
import { Task } from '@task-utils/types';
import { TaskRoutes } from '@task-utils/routes';
import { PlanFormResult } from './create-edit-shelf-plan.component';
import { GridChip } from './shelf-filler-calendar.component';

type InData = {
	chip?: GridChip;
	visit?: Task.ShelfVisit;
	can_edit?: boolean;
	can_no_show?: boolean;
};


@Component({
	selector: 'task-create-edit-shelf-plan-dialog',
	template: `
		<task-create-edit-shelf-plan
			[visit]="visit"
			[can_edit]="can_edit"
			[can_no_show]="can_no_show"
			(result)="on_result($event)"
			(action)="on_action($event)">
		</task-create-edit-shelf-plan>
	`,
})
export class CreateEditShelfPlanDialog extends ModalBase<InData, any> implements OnInit {
	preventSoftClose = true;
	visit: Task.ShelfVisit | null = null;
	can_edit = false;
	can_no_show = false;

	async ngOnInit() {
		this.can_edit = this.injectedData?.can_edit ?? false;
		this.can_no_show = this.injectedData?.can_no_show ?? false;

		const chip = this.injectedData?.chip;

		if (this.injectedData?.visit) {
			this.visit = this.injectedData.visit;
		} else if (chip) {
			this.visit = (await TaskRoutes.shelf.api_shelf_visit_get_single(chip.id)).data;
		}
	}

	async on_result(res: PlanFormResult | null) {
		if (res == null) { this.submit(false); return; }

		if (res.is_edit && res.shelf_visit_id) {
			await TaskRoutes.shelf.api_shelf_visit_modify(res.shelf_visit_id, {
				supplier_company_id: res.supplier_company_id ?? undefined,
				location_id: res.location_id,
				planned_visit_date: res.planned_visit_date,
				planned_visit_time: res.planned_visit_time,
				planned_work_type_ids: res.planned_work_type_ids,
				planned_note: res.planned_note,
				planned_worker_user_ids: res.planned_worker_user_ids,
			});
		} else if (res.mode === 'single') {
			await TaskRoutes.shelf.api_shelf_visit_add({
				supplier_company_id: res.supplier_company_id ?? undefined,
				location_id: res.location_id,
				planned_visit_date: res.planned_visit_date!,
				planned_work_type_ids: res.planned_work_type_ids,
				planned_visit_time: res.planned_visit_time,
				planned_note: res.planned_note,
				planned_worker_user_ids: res.planned_worker_user_ids,
			});
		} else {
			await TaskRoutes.shelf.api_shelf_visit_batch_add(
				(res.rows ?? []).map(r => ({
					supplier_company_id: res.supplier_company_id ?? undefined,
					location_id: res.location_id,
					planned_visit_date: r.planned_visit_date,
					planned_work_type_ids: res.planned_work_type_ids,
					planned_visit_time: r.planned_visit_time,
					planned_note: res.planned_note,
					planned_worker_user_ids: res.planned_worker_user_ids,
				})),
			);
		}

		this.submit(true);
	}

	on_action(a: 'delete' | 'no_show') {
		if (!this.visit) { return; }
		const id = this.visit.shelf_visit_id;
		const is_del = a === 'delete';
		modal.open(ConfirmDialogComponent, async (succ: boolean) => {
			if (!succ) { return; }
			if (is_del) { await TaskRoutes.shelf.api_shelf_visit_delete(id); }
			else { await TaskRoutes.shelf.api_shelf_visit_no_show(id); }
			this.submit('changed');
		}, {
			title: language.translate(is_del ? 'PUNJENJE.DELETE.TITLE' : 'PUNJENJE.NO_SHOW.TITLE'),
			message: language.translate(is_del ? 'PUNJENJE.DELETE.MSG' : 'PUNJENJE.NO_SHOW.MSG'),
			icon: is_del ? 'delete' : 'do_not_disturb',
			iconColor: color.variable(color.Variable.warn),
		});
	}
}
